export default {
  computed: {
    defaultActiveMenuIndex () {
      const {name: routeName} = this.$route
      const entity = this.indexOfRouterNameEntities
        .find(([, routeNames]) => {
          if (routeNames instanceof Array) {
            return routeNames.indexOf(routeName) >= 0
          } else {
            return routeNames === routeName
          }
        })
      return entity && entity[0]
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/nav.js